import { Injectable } from '@angular/core';
import { DialogService } from './dialog-service';

/** Opzioni di conferma: stessa forma di Confirmation di primeng, così il codice che chiama confirm() non cambia. */
export interface ConfirmOptions {
	message?: string;
	header?: string;
	acceptLabel?: string;
	rejectLabel?: string;
	accept?: () => unknown;
	reject?: () => unknown;
	// accettate per compatibilità (aspetto e ancoraggio di p-confirmDialog/p-confirmpopup), senza effetto
	key?: string;
	target?: EventTarget | null;
	icon?: string;
	acceptIcon?: string;
	rejectIcon?: string;
	acceptButtonStyleClass?: string;
	rejectButtonStyleClass?: string;
}

/**
 * Richiesta di conferma con sweetalert (DialogService.fireSwal), al posto di ConfirmationService +
 * p-confirmDialog/p-confirmpopup di primeng: accept se l'utente conferma, reject se annulla o chiude.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
	constructor(private _dialogService: DialogService) {}

	confirm(options: ConfirmOptions): void {
		this._dialogService
			.fireSwal(
				options.header || 'common_toast_confirm',
				options.message || '',
				'warning',
				options.acceptLabel || 'common_toast_confirm',
				options.rejectLabel || 'common_btn_cancel'
			)
			.then(result => (result.isConfirmed ? options.accept?.() : options.reject?.()));
	}
}
